<template>
<div>
  <div class="main">
    <h1 class="h1_01"><img src="img_cs/h1_1.png" alt="写真との出会いは、" /></h1>
    <h1 class="h1_02"><img src="img_cs/h1_2.png" alt="世界との出会いだ。" /></h1>
  
    <div class="vi_2021">
      <img src="img_cs/vi_2021.jpg" alt="10選2021" class="viImg" />
      <h2><img src="img_cs/h2.png" alt="An encounter with a photo is an encounter with the world" /></h2>
    </div>
  </div>

  <h1 class="mainSp">
    <img src="img_cs/vi_2021sp@2x.jpg" alt="写真との出会いは、世界との出会いだ。 An encounter with a photo is an encounter with the world" />
  </h1>
  

  <div class="exhTitle">
    <div class="exhTitleInner"><img src="img_cs/title.png" srcset="img_cs/title@2x.png 2x" alt="東京カメラ部2022写真展" /></div>
  </div>

  <div id="preopen">
  <div class="inner">
    <p>2022.9.16 13:00<br><span>OPEN</span></p>
  </div>
  </div>

  <footer>
    <div class="inner">
    <p class="about"><a href="https://corporate.tokyocameraclub.com/corporate02.php" target="_blank">主催：東京カメラ部株式会社【会社概要】</a></p>
    <p class="copyright">Copyright © Tokyo Camera Club Corp. All rights reserved.</p>
    </div><!-- /inner -->
  </footer>
</div>
</template>

<script>
import { mapGetters } from 'vuex'
import enumMixin from '@/concern/enumMixin'
import constMixin from '@/concern/constMixin'

export default {
  mixins: [enumMixin, constMixin], // Enum値, const値の読み込み
  components: {
  },
  data () {
    return {
    }
  },
  methods: {
  },
  computed: {
    ...mapGetters([
    ])
  },
  created () {
  },
  mounted () {
  },
  watch: {
  }
}
</script>

<style scoped>
* {
  -webkit-appearance: none;
  -moz-box-sizing: border-box;
}
*,
*::before,
*::after {
  box-sizing: border-box;
}
html{
  height: 100%;
  min-height: 100%;
}
body{
  height: 100%;
  min-height: 100%;
  width: 100%;
  margin: 0;
  padding: 0;
  overflow-y: visible;
  background: none repeat scroll 0 0 #fff;
  -webkit-text-size-adjust: 100%;
  font-family: 'Montserrat', "ヒラギノ角ゴ ProN W3", "Hiragino Kaku Gothic ProN", "游ゴシック", YuGothic, "メイリオ", Meiryo, sans-serif;
  color: #333;
  overflow-y: scroll;
  animation: fadeIn 1.5s ease 0s 1 normal;
}
@keyframes fadeIn {
    0% {opacity: 0}
    100% {opacity: 1}
}
img{
  vertical-align: bottom;
  margin:0;
  padding:0;
}
.inner{
  margin:0 auto;
  position:relative;
    width: 980px;
}


.clearfix:after {
  visibility: hidden;
  display: block;
  font-size: 0;
  content: " ";
  clear: both;
  height: 0;
}
* html .clearfix {
  zoom: 1;
} /* IE6 */
*:first-child+html .clearfix {
  zoom: 1;
} /* IE7 */
.fade {
  opacity: 1;
  transition: opacity .4s ease-in-out;
  -moz-transition: opacity .4s ease-in-out;
  -webkit-transition: opacity .4s ease-in-out;
}
.fade:hover {
  opacity: 0.5;
}




.sp{
  display: none;
}

.pc{
  display: block;
}



/* max-width:640px */
@media screen and (max-width:640px){
    
  .pc{
    display: none;
  }

  .sp{
    display: block;
  }

}

  
  
  

/* KV＆FOOT
-------------------------------------- */
#top{
  text-align: center;
  max-width: 1920px;
  margin: 0 auto;
}


.main{
  display: flex;
  justify-content: space-around;
  flex-wrap: nowrap;
  margin-bottom: 30px;
}
.mainSp{
  display: none;
}


.main .h1_01{
  order: 3;
  padding-top: 65px;
  margin: 0 20px;
}

.main .h1_02{
  order: 1;
  padding-top: 65px;
  margin: 0 20px;
}


.main .vi_2021{
  order: 2;
  width: 580px;
  text-align: center;
}

.main .vi_2021 h2{
  margin: 0 0 30px;
  
}

.main .vi_2021 .viImg{
  margin-bottom: 20px;
  
}


p#message{
  max-width: 960px;
  margin: 0 auto;
  text-align: justify;
  font-size: 16px;
  line-height: 40px;
  letter-spacing: 1px;
}
.exhTitle{
  padding: 80px 0;
  background: url("/public/img_cs/line_vertical.png") repeat-y center;
}
p#message,
.exhTitle{
  margin-bottom: 50px;
}  

.exhTitle .exhTitleInner{
  display: flex;
  justify-content: center;
  padding: 50px 0;
  background: #fff;
}



p#attention{
  max-width: 960px;
  margin: 0 auto 50px;
  text-align: justify;
  font-size: 12px;
  line-height: 20px;
  letter-spacing: 1px;
}


footer{
  background: #101010;
  text-align: center;
  margin: 0 auto;
  padding: 30px 0;
  border-bottom: 1px solid #333333;
}

footer .inner{
  color: #fff;
  margin: 0 auto;
    position: relative;
    width: 960px;
    min-width: 960px;
  text-align: justify;
  font-family: "Noto Sans JP";
  font-feature-settings: "palt";
  font-size: 14px;
  letter-spacing: 2px;
    line-height: 2.2em;
    font-weight: 300;
  text-align: center;
}


footer p.about{
  font-size: 14px;
  margin: 0 0 10px;
}
footer p.about a{
  color: #fff;
  text-decoration: none;

}
footer p.about a:hover{
  color: #868686;

}

footer p.copyright{
  font-size: 11px;
  letter-spacing: 1px;
  margin: 0 0 10px;
}







/* max-width:960px */
@media screen and (max-width:960px){
  
  .main{
    display: none;
  }
  .mainSp{
    display:block;
    margin-top: 0;
    margin-bottom: 40px;
    padding: 0 30px;
  }
  .mainSp img{
    width: 100%;
  }

  p#message{
    padding: 0 30px;

  }
p#attention{
    padding: 0 10px;
}
footer .inner{
    width: 100%;
    min-width: 100%;
}
}

/* max-width:640px */
@media screen and (max-width:640px){
  .mainSp{
    padding: 0 20px;
    margin-bottom: 20px;
  }
    p#message{
    font-size: 14px;
    line-height: 26px;
    padding: 0 20px;
    margin-bottom: 30px;
  }

  .exhTitle{
    padding: 50px 0;
    margin-bottom: 30px;
  }  
  .exhTitle .exhTitleInner{
    padding: 30px 30px;
  }
  .exhTitle .exhTitleInner img{
    width: 100%;
  }

  
footer .inner{
    width: 100%;
    min-width: 100%;
}
  
}



/* プレオープン
-------------------------------------- */
#preopen {
  margin-bottom: 80px;
  padding: 0 0 80px 0;
  background: url("/public/img_cs/line_vertical.png") repeat-y center;
}
#preopen .inner{
  color: #000;
  margin: 0 auto;
    position: relative;
    width: 960px;
  text-align: center;
  font-family: "Noto Sans JP";
  font-feature-settings: "palt";
}
#preopen p {
  margin: 0 auto;
  padding: 0 0 50px;
  font-size: 28px;
  letter-spacing: 2px;
  line-height: 36px;
    font-weight: 300;
  background: #fff;
}
#preopen p span {
  font-size: 20px;
}

/* max-width:960px */
@media screen and (max-width:960px){
  #preopen .inner{
    width: 100%;
    min-width: 100%;
    padding: 0 20px;
  }
}

/* max-width:640px */
@media screen and (max-width:640px){
  #preopen{
    padding: 0 0 60px 0;
  }
  #preopen .inner{
    width: 100%;
    min-width: 100%;
    padding: 0 20px;
  }
  #preopen p {
    margin: 0 auto;
    padding: 0 0 40px;
    background: #fff;
    font-size: 22px;
  }
  #preopen p span {
    font-size: 18px;
  }
}

</style>
